/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Fence } from '../../models/fence';

export interface Fencesbyrace$Params {
  raceGuid: string;
}

export function fencesbyrace(http: HttpClient, rootUrl: string, params: Fencesbyrace$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Fence>>> {
  const rb = new RequestBuilder(rootUrl, fencesbyrace.PATH, 'get');
  if (params) {
    rb.path('raceGuid', params.raceGuid, {"style":"simple"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Fence>>;
    })
  );
}

fencesbyrace.PATH = '/races/{raceGuid}/fences';
